import React, { useState, useEffect } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase/config';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

    useEffect(() => {
      const userId = localStorage.getItem('loggedInUserId');
      if (userId) {
        navigate('/');
      }
    }, [navigate]);

    // Disable right-click and common inspect shortcuts
    useEffect(() => {
      const handleContextMenu = (e) => e.preventDefault();
    
      const handleKeyDown = (e) => {
        if (e.key === 'F12') {
          e.preventDefault();
          return false;
        }
        if (
          (e.ctrlKey || e.metaKey) && 
          (e.shiftKey && ['I', 'J', 'C', 'K'].includes(e.key.toUpperCase()))
        ) {
          e.preventDefault();
          return false;
        }
        if (
          (e.ctrlKey || e.metaKey) &&
          ['U', 'S', 'P'].includes(e.key.toUpperCase())
        ) {
          e.preventDefault();
          return false;
        }
      };
    
      window.addEventListener('contextmenu', handleContextMenu);
      window.addEventListener('keydown', handleKeyDown);
    
      return () => {
        window.removeEventListener('contextmenu', handleContextMenu);
        window.removeEventListener('keydown', handleKeyDown);
      };
    }, []);


  const showMessage = (msg, error = false) => {
    setMessage(msg);
    setIsError(error);
    setVisible(true);
    setTimeout(() => setVisible(false), 5000);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, email);
      showMessage('Password reset link has been sent to your email.');
      setTimeout(() => navigate('/login'), 4000);
    } catch (error) {
      let userMessage = '';
      switch (error.code) {
        case 'auth/invalid-email':
          userMessage = 'Invalid email address. Please check and try again.';
          break;
        case 'auth/user-not-found':
          userMessage = 'No account found with this email address.';
          break;
        case 'auth/missing-email':
          userMessage = 'Please enter an email address.';
          break;
        case 'auth/network-request-failed':
          userMessage = 'Network error. Please try again.';
          break;
        default:
          userMessage = 'Error: ' + error.message;
      }
      showMessage(userMessage, true);
    }
  };

  return (
    <>
      <Header />
      <div className="login-page" style={{ backgroundColor: '#FFFDF6' }}>
        <div className="container d-flex align-items-center vh-100">
          <div className="form-holder shadow-lg w-100">
            <div className="row">
              {/* Info Panel */}
              <div className="col-lg-6 position-relative text-center" style={{ backgroundColor: '#113d6e'}}>
                <img
                  src="/images/logofs.png"
                  alt="logo"
                  width="200"
                  height="120"
                  className="position-absolute top-0 start-50 translate-middle-x mt-5 d-lg-block d-none"
                />
                <div className="info d-flex flex-column justify-content-center h-100 text-light">
                  <div className="content d-lg-block d-none">
                    <h1>Forgot Password</h1>
                  </div>
                  {visible && (
                    <div
                      className="messageDiv"
                      style={{
                        marginTop: '10px',
                        color: isError ? 'red' : 'lightgreen',
                        transition: 'opacity 0.5s',
                        opacity: visible ? 1 : 0,
                      }}
                    >
                      {message}
                    </div>
                  )}
                </div>
                <img
                  src="/images/india.png"
                  alt="india"
                  width="100%"
                  className="position-absolute bottom-0 start-0"
                />
              </div>

              {/* Form Panel */}
              <div className="col-lg-6 bg-white d-flex align-items-center p-5">
                <div className="w-100 px-4">
                  <form onSubmit={handleResetPassword}>
                    <h2 className="mb-5">Reset Your Password</h2>

                    <div className="form-group mb-4">
                      <label>Email Address</label>
                      <input
                        type="email"
                        className="form-control"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your registered email"
                      />
                    </div>

                    <div className="text-center">
                      <button type="submit" className="btn btn-info w-100">
                        Send Reset Link
                      </button>
                    </div>
                  </form>

                  <div className="text-center mt-4">
                    <a href="/login">Back to Login</a>
                    <p className="mb-0 mt-3">
                      &copy; {new Date().getFullYear()} Freshskills. All rights reserved.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ForgotPasswordPage;
